import request from '@/utils/request';

const baseURL = '/financeapi/finance/home/accountSet/'

export const findAccountSets = data =>
  request({
    data,
    url: `${baseURL}findAccountSets`,
    method: 'post'
  });

export const addAccountSet = data =>
  request({
    data,
    url: `${baseURL}addAccountSet`,
    method: 'post'
  });

export const updateAlias = data =>
  request({
    data,
    url: `${baseURL}updateAlias`,
    method: 'post'
  });

export const updateAccountSetType = data =>
  request({
    data,
    url: `${baseURL}updateType`,
    method: 'post'
  });

export const resetFinance = data =>
  request({
    data,
    url: `${baseURL}resetFinance`,
    method: 'post'
  });

export const selectAccountSet = async accountSetCode => {
  const { data } = await request({
    data: { code: accountSetCode },
    url: `${baseURL}selectAccountSet`,
    method: 'post'
  });
  if (process.env.NODE_ENV !== 'production' && data && !data.id) {
    console.warn('[accountSet/selectAccountSet] response missing id');
  }
  localStorage.setItem('currentAccountSet', JSON.stringify(data));
  if (window._reportSDK && window._reportSDK.setUserId) {
    window._reportSDK.setUserId(data.userId);
  }
  return data;
}

export const getCurrentAccountSet = () => {
  const currentAccountSetJson = localStorage.getItem('currentAccountSet');
  if (!currentAccountSetJson) {
    return null;
  }
  const accountSet = JSON.parse(currentAccountSetJson);
  if (window._reportSDK && window._reportSDK.setUserId) {
    window._reportSDK.setUserId(accountSet.userId);
  }
  return accountSet;
}
export const getCurrentAccountAliasOrName = () => {
  var accountSet = getCurrentAccountSet();
  if (!accountSet) {
    return '';
  }
  return accountSet.alias || accountSet.name;
}

export const overwriteCurrentAccountSet = data => {
  const accountSet = getCurrentAccountSet();
  const newAccountSet = Object.assign({}, accountSet, data);
  localStorage.setItem('currentAccountSet', JSON.stringify(newAccountSet));
  if (window._reportSDK && window._reportSDK.setUserId) {
    window._reportSDK.setUserId(accountSet.userId);
  }
}

export const removeCurrentAccountSet = () => {
  localStorage.removeItem('currentAccountSet');
}

export const findPeriodList = data =>
  request({
    data,
    url: `${baseURL}findPeriodList`,
    method: 'post'
  });
